import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppShell } from "../components/AppShell";
import { LoadingState } from "../components/AsyncState";
import { NotFoundPage } from "../components/NotFoundPage";

const PublicRecipesPage = lazy(() =>
  import("../features/public-recipes/PublicRecipesPage").then((module) => ({ default: module.PublicRecipesPage })),
);
const RecipePage = lazy(() =>
  import("../features/public-recipes/RecipePage").then((module) => ({ default: module.RecipePage })),
);
const PlannerPage = lazy(() =>
  import("../features/planner/PlannerPage").then((module) => ({ default: module.PlannerPage })),
);
const AdminPage = lazy(() =>
  import("../features/admin/AdminPage").then((module) => ({ default: module.AdminPage })),
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppShell>
          <Suspense fallback={<LoadingState />}>
            <Routes>
              <Route path="/" element={<PublicRecipesPage />} />
              <Route path="/r/:shareRef" element={<RecipePage />} />
              <Route path="/planner" element={<PlannerPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </AppShell>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
